import React, { FC } from 'react';
import { find } from 'lodash';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import { UpdateGroupInput } from 'api';
import { IMGIX_HOST } from 'settings';
import { useGroupData } from 'features/groups/hooks';

import { getGroupHexColor } from '../../helpers';

interface IProps {
  size: number;
}

const MIN_SIZE = 2; // imgix min - protecting against 0

const useStyles = makeStyles(theme => ({
  imageWrapper: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    marginBottom: theme.spacing(2),
    borderRadius: 4,
  },
}));

const Image: FC<IProps> = ({ size }) => {
  const classes = useStyles();
  const { values } = useFormikContext<UpdateGroupInput>();
  const { groupIcons, groupColors } = useGroupData();

  const hexColor = getGroupHexColor(groupColors, values.color);

  function getLocalUrl() {
    const { image } = values;

    if (!image?.localUri) {
      return '';
    }

    return window.URL.createObjectURL(image.localUri);
  }

  function getIconUrl() {
    const { icon } = values;
    const safeSize = Math.max(MIN_SIZE, size);
    const match = find(groupIcons, ['group_icon', icon]);

    return `${IMGIX_HOST}/${match.file_key}?auto=format&h=${safeSize}&w=${safeSize}`;
  }

  function getSrc() {
    const src = getIconUrl();
    const localUrl = getLocalUrl();
    const { image } = values;
    const safeSize = Math.max(MIN_SIZE, size);

    if (!image) {
      return src;
    }

    const savedUrl = `${IMGIX_HOST}/${image.key}?auto=format&h=${safeSize}&w=${safeSize}`;
    return localUrl ? localUrl : savedUrl;
  }

  return (
    <div
      className={classes.imageWrapper}
      style={{
        width: size,
        height: size,
        backgroundColor: hexColor,
        backgroundImage: `url(${getSrc()})`,
      }}
    />
  );
};

export default Image;
